import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import Label from '../Label';
import ArrowRight from '../../../Icons/ArrowRight';
import ArrowDown from '../../../Icons/ArrowDown';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import ConditionalTooltip from '../ConditionalTooltip';
import s from './FoldableGroup.scss';
var FoldableGroup = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, icon = _a.icon, isCollapsed = _a.isCollapsed, title = _a.title;
    var foldableRef = useRef(null);
    var _c = useState(false), isFolded = _c[0], setIsFolded = _c[1];
    return (React.createElement("div", { className: classnames(s['root'], isCollapsed && s['collapsed'], isFolded && s['folded'], className) },
        React.createElement(ConditionalTooltip, { showTooltip: isFolded && !!isCollapsed, tooltipContent: title },
            React.createElement(PlainButtonOrLink, { className: s['link'], onClick: function () { return setIsFolded(function (folded) { return !folded; }); } },
                React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed, icon: icon },
                    title,
                    ' ',
                    isFolded ? (React.createElement(ArrowRight, { size: IconSize.SMALLER, className: s['arrow'] })) : (React.createElement(ArrowDown, { size: IconSize.SMALLER, className: s['arrow'] }))))),
        React.createElement("div", { className: s['foldable'], style: isFolded ? {} : { maxHeight: (_b = foldableRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight } },
            React.createElement("div", { ref: foldableRef }, children))));
};
FoldableGroup.displayName = 'FoldableGroup';
export default FoldableGroup;
//# sourceMappingURL=FoldableGroup.js.map